import { render, staticRenderFns } from "./CustomValuesEditor.vue?vue&type=template&id=4b01be4a&scoped=true&"
import script from "./CustomValuesEditor.vue?vue&type=script&lang=ts&"
export * from "./CustomValuesEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b01be4a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
